class MFRScrollingCarousel {
  constructor(i, e, options) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {};

    this.pauseOnDrag = options["pauseOnDrag"];
    this.init();
  }

  init() {
    this.checkViewport();
    window.onWidthResize(() => {
      this.checkViewport();
    });
  }

  checkViewport() {
    let items = this.getCarouselItems();
    let totalItemsWidth = this.getTotalItemsWidth(items);
    let getCarouselWidth = this.$element.outerWidth();
    if (totalItemsWidth >=getCarouselWidth ) {
      this.initCarousel();
    } else {
      if (this.$element.hasClass("flickity-enabled")) {
        this.$carousel.destroy();
      }
      this.reappendCarouselItems();
      this.checkViewport();
    }
  }

  initCarousel() {
    if (this.$element.hasClass("flickity-enabled")) return;
    this.$carousel = new Flickity(this.$element.get(0), {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      groupCells: true,
      cellAlign: "center",
      imagesLoaded: true,
      on: {
        ready: () => {
          this.refreshOnImageLoad();
        }
      }
    });

    this.$carousel.x = 0;

    this.play();

    if (this.pauseOnDrag) {
      this.$element
        .on("pointerDown.flickity", () => {
          this.pause();
        })
        .on("mouseleave", () => {
          if (!this.$element.hasClass("paused")) return;
          this.$element.removeClass("paused");
          this.play();
        });
    }
  }

  play() {
    this.$carousel.x -= 1;

    this.$carousel.settle(this.$carousel.x);

    this.requestId = window.requestAnimationFrame(this.play.bind(this));
  }

  pause() {
    this.$element.addClass("paused");
    if (this.requestId) {
      window.cancelAnimationFrame(this.requestId);
      this.requestId = undefined;
    }
  }

  getCarouselItems() {
    let items;
    if (this.$element.hasClass("flickity-enabled")) {
      items = this.$element.find(".flickity-slider > *");
    } else {
      items = this.$element.find("> *");
    }
    return items;
  }

  getTotalItemsWidth(items) {
    // Get total width of items when combined.
    let totalWidth = 0;

    // Loop through the items to get the total width.
    items.each(function (i,e) {
      if(i == items.length - 1) return;
      totalWidth += $(this).outerWidth(true);
    });

    return totalWidth;
  }

  reappendCarouselItems() {
    this.$element.find("> *").each( (i,e) => {
      this.$element.append($(e).clone());
    });
  }

  refreshOnImageLoad() {
    this.$element.find("img").one("load error", (e) => {
      this.$carousel.resize();
    });
  }
}
